import fetch from 'utils/fetch'

// 首页消息
export function fetchAppList(params) {
  return fetch({
    url: '/market/application/search',
    method:'GET',
    params
  })
}